import PriceVolatilityMarket from './PriceVolatilityMarket';

export default PriceVolatilityMarket;
